/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */


 document.addEventListener('variant:changed', function(event) {
    var variant = event.detail.variant; // Gives you access to the whole variant details
     if (variant) {
        $('.variant-sku').text(variant.sku);
       console.log('name: ', variant.name);
       if(variant.name.includes("build your own"))
          {
            //apologies for hardcoding!
             var t = document.getElementsByClassName("ProductForm__SelectedValue");
             var glength = t[0].textContent;
             var gcolor = t[1].textContent;
             var gbacking = t[2].textContent;
            
              
            console.log('selected: ', glength);
            console.log('selected: ', gcolor);
            console.log('selected: ', gbacking);  
                  
           
            if(variant.name.includes("/ Black /"))
            {
              console.log('BLACK CS');
              
              
              var x = document.getElementsByClassName("Popover__Value");
              for(i=0; i < x.length; i++ )
              {
                //console.log(x[i].textContent);
                
                  if(x[i].textContent.includes("(Brown girth)"))
                   {
                   	console.log("hide this guy via custom script");
                     x[i].style.visibility = 'hidden';
                   }
                   else
                   {
                     x[i].style.visibility = 'visible';
                     
                   }
              
              }
              //set default
              if (gbacking.includes("(Brown girth)"))
              {
                  console.log("mismatch...");
               	  t[2].textContent = "Please select..."; 
              }
              
            }//end if black
            
            if(variant.name.includes("/ Brown /"))
            {
              console.log('BROWN CS');
              var x = document.getElementsByClassName("Popover__Value");
              for(i=0; i < x.length; i++ )
              {
                //console.log(x[i].textContent);
                
                  if(x[i].textContent.includes("(Black girth)"))
                   {
                   	console.log("hide this guy via custom script");
                     x[i].style.visibility = 'hidden';
                   }
                else
                   {
                     x[i].style.visibility = 'visible';
                   }
              
              }
              
              if (gbacking.includes("(Black girth)"))
              {
                  console.log("mismatch...");
               	  t[2].textContent = "Please select..."; 
              }
              
              
            }//end if brown
            
          }
       
		}
	  else {
        $('.variant-sku').empty();
		}
  });

  $(document).on('click', '.SidebarMenu__Nav--primary .Collapsible__Inner .Collapsible__Button', function() {
    toggleClass($(this))
  })

  $(document).on('click', '.back_button', function() {
    $(this).parent().parent().parent().find('.collapse-child-parent').click()
    //$(this).parent().parent().parent().parent().find('.collapse-child-parent').click()
  })

  function toggleClass(e) {
    e.parent().addClass('show-child-menu')
    if($('.SidebarMenu__Nav--primary').hasClass('show-child')) {
      e.parent().removeClass('show-child-menu')
      $('.SidebarMenu__Nav--primary').removeClass('show-child')
      $('.SidebarMenu__Nav--secondary').show()
      return
    }
    $('.SidebarMenu__Nav--primary').addClass('show-child')
    $('.SidebarMenu__Nav--secondary').hide()
  }

/**
  $(document).ready(function() {
    $('.dn-collection-carousel').slick({
        infinite: true,
        dots: false,
        slidesToShow: 7,
        slidesToScroll: 3,
        arrows: false,
        focusOnSelect: false,
        centerPadding: '0',
        speed: 500, 
      	swipeToSlide: true,
        cssEase: 'cubic-bezier(0.770, 0.000, 0.175, 1.000)',
        responsive: [
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 3,
							slidesToScroll: 1
						}
					}
				]
    })
  })
  
   */
